export default "__VITE_ASSET__BMqooqcb__"